const API_ORIGIN =
  process.env.REACT_APP_API_ORIGIN ||
  process.env.REACT_APP_TASK_API_ORIGIN ||
  "https://fundswalla.in";

const ABSOLUTE_TASK_API_FLAG =
  process.env.REACT_APP_FORCE_ABSOLUTE_TASK_API === "1";

const buildRelativeUrl = (prefix, endpoint) =>
  `${prefix}/${String(endpoint).replace(/^\//, "")}`;

const buildAbsoluteUrl = (prefix, endpoint) =>
  `${API_ORIGIN}${buildRelativeUrl(prefix, endpoint)}`;

/**
 * Prefer same-origin paths so live sites can proxy `/Api` without CORS issues.
 * Set `REACT_APP_FORCE_ABSOLUTE_TASK_API=1` only if reverse proxy is unavailable.
 */
export const taskApiPostUrl = (endpoint) =>
  ABSOLUTE_TASK_API_FLAG
    ? buildAbsoluteUrl("/Api/TaskApi", endpoint)
    : buildRelativeUrl("/Api/TaskApi", endpoint);

export const taskApiDirectUrl = (endpoint) =>
  buildAbsoluteUrl("/Api/TaskApi", endpoint);

/** PAN / Aadhaar OTP */
export const loanBackendUrl = (endpoint) =>
  buildAbsoluteUrl("/loan_backend", endpoint);

/** Lead save via TaskApi */
export const saveLendingPageUrl = () => taskApiPostUrl("saveLendingPage");

export const formatApiMessage = (message) => {
  if (typeof message !== 'string') return 'Something went wrong. Please try again.';
  return message.replace(/<br\s*\/?>/gi, '\n').replace(/<[^>]+>/g, '').trim();
};

/** Normalize success from TaskApi or loan_backend save responses */
export const isLeadSaveSuccess = (data) => {
  if (!data || typeof data !== 'object') return false;
  if (data.Status === 1 || data.status === 1) return true;
  if (data.success === true) return true;
  return false;
};

export const getLeadSaveMessage = (data, fallback = 'Something went wrong. Please try again.') =>
  formatApiMessage(data?.Message || data?.message || data?.error || fallback);

export const getLeadInsertedId = (data) =>
  data?.inserted_id || data?.insertedId || data?.Data?.inserted_id || data?.id || null;
